import { Card, useDialog } from "@fpsoftware/mvp";
import type { ComponentProps } from "react";
import { TbEdit } from "react-icons/tb";
import type { Borrower } from "shared";
import { EditBorrowerDialog } from "@/borrower/EditBorrowerDialog";
import { useSuspenseBorrower } from "@/borrower/hooks";
import { Button } from "@/components/Button";
import styles from "./BorrowerCard.module.css";

function getMailToLink(borrower: Borrower) {
  const name = encodeURIComponent(`${borrower.firstName} ${borrower.lastName}`);
  return `mailto:${name}<${borrower.email}>`;
}

export function BorrowerCard(
  props: { borrowerID: number } & ComponentProps<typeof Card>,
) {
  const { borrowerID, ...rest } = props;
  const borrower = useSuspenseBorrower(borrowerID);
  const dialog = useDialog();

  const handleEditBorrower = () =>
    dialog.open(EditBorrowerDialog, { borrower });

  return (
    <Card {...rest}>
      <Card.Header>
        Borrower
        <Button size="sm" icon={TbEdit} onClick={handleEditBorrower}>
          Edit borrower
        </Button>
      </Card.Header>
      <Card.List>
        <Card.ListItem label="Name">
          {borrower.firstName} {borrower.lastName}
        </Card.ListItem>
        <Card.ListItem label="Email">
          <a href={getMailToLink(borrower)} className={styles.email}>
            {borrower.email}
          </a>
        </Card.ListItem>
        <Card.ListItem label="Credit Score">
          {borrower.creditScore ?? "-"}
        </Card.ListItem>
      </Card.List>
    </Card>
  );
}
